/*
  Plans — the plan switch.

  Shows one plan panel at a time. Each panel already holds that plan's three
  priced term cards, rendered server-side, so this file never creates or writes
  price content: it only flips which panel is hidden. Prices are legal
  statements and live in the section settings where they can be checked against
  the price list.

  Every panel is in the DOM with the first one visible and the rest `hidden`, so
  with JavaScript off the page is correct and readable at the first plan and the
  switch does nothing. Each term card carries its own add-to-cart form with its
  own variants rendered server-side. JavaScript adds both items using Shopify's
  JSON cart API. Without JS, the native single-variant form adds the selected
  membership; the cart links to the Plug page to complete the pair.

  Guard product pages use the same purchase controller for their selected term.
  With a single plan or a product page, only the purchase forms are initialized.
*/
(function () {
  function Plans(root) {
    this.root = root;
    this.inputs = Array.prototype.slice.call(root.querySelectorAll('[data-plan-input]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-plan-panel]'));
    this.adding = false;
    root.querySelectorAll('.miles-plans__buy-form').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.addPair(form);
      });
    });

    if (!this.inputs.length || this.panels.length < 2) return;

    var self = this;
    this.inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) self.show(input.value);
      });
    });

    // Honour a ?plan= in the URL so a link can point at a specific plan.
    // Anything that does not match a rendered panel is ignored rather than
    // trusted.
    var requested = new URLSearchParams(window.location.search).get('plan');
    if (requested) {
      var match = this.inputs.filter(function (i) {
        return i.value === requested || i.getAttribute('data-plan-key') === requested;
      })[0];
      if (match) {
        match.checked = true;
        this.show(match.value);
      }
    }
  }

  Plans.prototype.addPair = async function (form) {
    if (this.adding) return;
    this.adding = true;
    this.root.querySelectorAll('.miles-plans__buy-form button').forEach((button) => { button.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(form.getAttribute('action') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [
          { id: Number(form.dataset.plugVariant), quantity: 1 },
          { id: Number(form.elements.namedItem('id').value), quantity: 1 },
        ] }),
      });
      const result = await response.json();
      if (!response.ok || result.errors || result.status) throw new Error('request');
      window.location.assign(form.elements.namedItem('return_to').value);
    } catch (_) {
      // A failed response may follow a successful mutation. Require cart review
      // before retrying so an ambiguous result cannot duplicate the purchase.
      form.querySelector('[data-cart-error]').hidden = false;
    } finally {
      form.removeAttribute('aria-busy');
    }
  };

  Plans.prototype.show = function (planId) {
    this.panels.forEach(function (panel) {
      // `hidden` rather than a class: it takes the other plan's three prices
      // out of the accessibility tree too. Leaving them visually hidden but
      // present would have a screen reader read six prices for one plan.
      panel.hidden = panel.getAttribute('data-plan-panel') !== planId;
    });
  };

  function init() {
    var roots = document.querySelectorAll('miles-plans, [data-miles-plans]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.milesPlansReady === 'true') return;
      root.dataset.milesPlansReady = 'true';
      new Plans(root);
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
  // A cached return from the cart must not retain disabled add buttons or stale
  // availability from the previous request.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload();
  });
})();
